module.exports = __webpack_public_path__ + "static/media/msr.1e087bc2.svg";